export const TECHNICAL_FIELDS = ['useMultiPageCanvas', 'saveCanvasForCurrentPage'];

export const stripTechnicalFields = obj => {
    if (!obj) return {};
    const copy = { ...obj };
    TECHNICAL_FIELDS.forEach(field => delete copy[field]);
    return copy;
};
